const icon = require('vue-svgicon');
icon.register({
    'file': {
        width: 1024,
        height: 1024,
        viewBox: '0 0 1024 1024',
        data: `<path pid="0" d="M960.937 230.4l-227.2-224c-3.2-3.2-6.4-6.4-12.8-6.4h-422.4c-64 0-115.2 54.4-115.2 121.6v332.8h-124.8V848h124.8v54.4c0 67.2 51.2 121.6 115.2 121.6h550.4c64 0 115.2-54.4 115.2-121.6V243.2c3.2-6.4 0-9.6-3.2-12.8zm-246.4-192l198.4 195.2h-108.8c-51.2 0-89.6-38.4-89.6-89.6V38.4zm217.6 864c0 48-35.2 86.4-80 86.4h-553.6c-44.8 0-80-38.4-80-86.4V848h569.6V652.8 454.4h-569.6V121.6c0-48 35.2-86.4 80-86.4h380.8V144c0 70.4 57.6 124.8 124.8 124.8h124.8l3.2 633.6zm-704-262.4v32h-89.6v96h-38.4V540.8h144v28.8h-105.6V640h89.6zm512 99.2V768h-144V540.8h144v28.8h-108.8V640h92.8v32h-92.8v67.2h108.8zm-291.2 0h108.8V768h-144V540.8h35.2v198.4zm-112-198.4V768h-35.2V540.8h35.2z"/>`,
    },
});
